<template>
  <el-form class="" status-icon :model="opt" ref="searchbartwo">
    <el-form-item class="">
      Supplier Name :
      <el-input
        v-model.trim="opt.suppliername"
        :clearable="true"
        style="width:200px"
      ></el-input>
      <span style="color:red">*</span>&nbsp;&nbsp;&nbsp;
      Tender #. :
      <el-input
        v-model.trim="opt.tenderNo"
        :clearable="true"
        style="width:200px"
      ></el-input>
       <span style="color:red">*</span>&nbsp;&nbsp;&nbsp;
       <el-button
          class="btn-search btn-gray"
          icon="el-icon-search"
          @click="query"
        ></el-button>
    </el-form-item>
  </el-form>
</template>
<script>
//import { isNotNullORBlank, getQueryStr } from "../../utils/utils";
export default {
  name: "searchbartwo",
  data() {
    return {};
  },
  props: {
    opt: {
      type: Object,
      default: () => {
        return {
          suppliername:"",
          tenderNo:""
        };
      }
    }
  },
  methods: {
    query() {
      // console.log(!this.opt.suppliername);
      let suppliername = this.opt.suppliername;
      let terderNo = this.opt.tenderNo;
      // console.log(this.opt.tenderNo);
      if(!suppliername || !terderNo){
        this.$message.error("Please confirm whether the required items of the following search items have been filled in:"); 
      }else{
        this.$emit("query", {
          suppliername: this.opt.suppliername,
          tenderNo: this.opt.tenderNo
        });
      }
    }
      
  }
};
</script>
<style>
.ui-searchbar .el-select .el-input {
  width: 200px;
}

.ui-searchbar .el-input-group__prepend {
  background-color: #fff;
  /*border-color: #bfbfbf*/
}

.ui-searchbar .el-input-group__append {
  background-color: #ccc;
  color: #666;
  /*border-color: #bfbfbf*/
  border: 1px solid #ccc;
}

.ui-searchbar .el-input-group__append:hover,
.ui-searchbar .el-input-group__append:active {
  background-color: #a50606;
  color: #fff;
  border: 1px solid #a50606;
}

.ui-searchbar .el-input-group__prepend {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}

.ui-searchbar .el-input__inner:first-child {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
}

.ui-searchbar .el-input-group__append {
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  overflow: hidden;
}
</style>
<style scoped>
.ui-searchbar {
  /* padding: 20px 20px 0; */
  background: white;
  overflow: hidden;
}
.btn-search {
  /* border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px; */
}
</style>